import { environment } from 'src/environments/environment';
import { WelcomeCard } from './models/card.type';

export const sharedWelcomeCards: WelcomeCard[] = [
  {
    title: 'Industry Perspectives',
    description:
      'Listen to first-hand perspectives on Digital Asset investing from industry leaders and peers working within the financial industry.',
    linkTo: 'industry-perspectives',
    image: {
      url: '/assets/imgs/box-nav/box-nav-industry-perspectives_x2.png',
      alt: 'A trio of 2d drawn people look up at the yellow grid of blocks hanging in the matte blue sky for perspective',
      title:
        'Digital asset investing perspectives from industry leaders and peers',
      width: '400',
    },
    a11yImages: [
      {
        type: 'image/webp',
        srcset: '/assets/imgs/box-nav/box-nav-industry-perspectives_x2.webp',
      },
      {
        type: 'image/png',
        srcset: '/assets/imgs/box-nav/box-nav-industry-perspectives_x2.png',
      },
    ],
  },
  {
    title: 'Stories From the Street',
    description:
      'Learn from real-world scenarios your peers encounter in their daily practice. Gain insights and build a knowledge base to navigate your clients interest in this asset class.',
    image: {
      url: '/assets/imgs/box-nav/box-nav-Street-stories_2x.png',
      alt: 'Against a backdrop street corner in hues of blue, our 2d people are admiring the NFT images seen on the billboard, while others discuss the details of how it works.',
      title:
        "Learn from real world scenarios and gain insight to navigate your clients' interest",
      width: '400',
    },
    linkTo: 'stories-from-the-street',
    a11yImages: [
      {
        type: 'image/webp',
        srcset: '/assets/imgs/box-nav/box-nav-Street-stories_2x.webp',
      },
      {
        type: 'image/png',
        srcset: '/assets/imgs/box-nav/box-nav-Street-stories_2x.png',
      },
    ],
  },
  {
    title: 'Glossary',
    description:
      'A dynamic glossary designed to give you a complete understanding of important terms and definitions to help you as you explore Digital Assets.',
    image: {
      url: '/assets/imgs/box-nav/box-nav-Glossary-A-Thumb_2x.png',
      alt: 'A drawn pair of yellow glasses float on a blue-hued background, surrounded by glossary terms used in the digital world.',
      title:
        'A digital asset glossary to help understand terms and definitions',
      width: '400',
    },
    linkTo: 'https://amilearn.ca/glossary-index/',
    external: true,
    target: '_blank',
    a11yImages: [
      {
        type: 'image/webp',
        srcset: '/assets/imgs/box-nav/box-nav-Glossary-A-Thumb_2x.webp',
      },
      {
        type: 'image/png',
        srcset: '/assets/imgs/box-nav/box-nav-Glossary-A-Thumb_2x.png',
      },
    ],
  },
  {
    title: 'Ask an Expert',
    description:
      'Access to expert advice at your fingertips. Connect with industry experts who can help facilitate applying your foundational knowledge to your Digital Asset practice.',
    image: {
      url: '/assets/imgs/box-nav/box-nav-ask-an-expert_x2.png',
      alt: 'A professional stands confident in their blue suit, ready to answer the yellow and blue questionmarked bubbles coming at them from all sides.',
      title: 'Get access to Digital Asset industry experts',
      width: '400',
    },
    linkTo: 'https://amilearn.ca/experts/',
    external: true,
    target: '_blank',
    a11yImages: [
      {
        type: 'image/webp',
        srcset: '/assets/imgs/box-nav/box-nav-ask-an-expert_x2.webp',
      },
      {
        type: 'image/png',
        srcset: '/assets/imgs/box-nav/box-nav-ask-an-expert_x2.png',
      },
    ],
  },
  {
    title: 'Digital Assets Reading Room',
    description:
      'Looking for deeper reading on a topic? The Digital Asset Reading Room provides links to popular books on blockchain topics.',
    image: {
      url: '/assets/imgs/box-nav/box-nav-reading-room_x2.png',
      alt: 'A wealth advisor sits near shelves of books, one in hand, deepening their knowledge of digital assets.',
      title:
        'Dive into the Digital Assets Reading Room and find links to industry resources',
      width: '400',
    },
    linkTo: 'digital-assets-reading-room',
    a11yImages: [
      {
        type: 'image/webp',
        srcset: '/assets/imgs/box-nav/box-nav-reading-room_x2.webp',
      },
      {
        type: 'image/png',
        srcset: '/assets/imgs/box-nav/box-nav-reading-room_x2.png',
      },
    ],
  },
];

export const welcomeCards: WelcomeCard[] = [
  {
    title: 'Learning Bites',
    description:
      'Begin your learning with some key fundamentals of Digital Assets. Learning bites are short reads to give you an introduction to course content and get you started on your learning journey.',
    image: {
      url: '/assets/imgs/box-nav/box-nav-learning-bites_x2.png',
      alt: 'Yellow blockchain boxes decorated in blue and yellow frosting to demonstrate that knowledge can be consumed in snack sizes.',
      title: 'Start your learning journey in small, attainable sessions',
      width: '400',
    },
    linkTo: 'learning-bites',
    a11yImages: [
      {
        type: 'image/webp',
        srcset: '/assets/imgs/box-nav/box-nav-learning-bites_x2.webp',
      },
      {
        type: 'image/png',
        srcset: '/assets/imgs/box-nav/box-nav-learning-bites_x.png',
      },
    ],
  },
  ...sharedWelcomeCards,
];

export const welcomeSubscribedCards: WelcomeCard[] = [
  {
    title: 'AmiLearn Dashboard',
    description:
      'Access all your subscribed learning content, lessons and resources from your AmiLearn Dashboard.',
    image: {
      url: '/assets/imgs/box-nav/box-nav-goto-absorb-dashboard_2x.png',
      alt: "AmiLearn's Learning dashboard layout in blues and yellows, courses and lessons organized into rows with state of lesson indicated by color.",
      title: 'Access your subscribed content from AmiLearn',
      width: '400',
    },
    linkTo: environment.amilearnDashboardUrl,
    external: true,
    a11yImages: [
      {
        type: 'image/webp',
        srcset: '/assets/imgs/box-nav/box-nav-goto-absorb-dashboard_2x.webp',
      },
      {
        type: 'image/png',
        srcset: '/assets/imgs/box-nav/bbox-nav-goto-absorb-dashboard_2x.png',
      },
    ],
  },
  ...sharedWelcomeCards,
];
